import React, { useEffect } from 'react';
import { tryApplyReferenceModel, tryApplyReferenceGenerationInfo, tryApplyRemixInfo } from '@shakkerai/pro-utils';
import { useProjectState } from '../../store';

// 旧的 referer 处理逻辑（有机会再迁移到新的来）
export const LegacyRefererHandler = React.memo(() => {
  // TODO: 在这里判断数据是否已经初始化
  const initialized = useProjectState('__initialized');

  useEffect(() => {
    if (initialized) {
      console.log(`[DEBUG] referer module ready`);
      tryApplyReferenceModel();
      tryApplyReferenceGenerationInfo();
      tryApplyRemixInfo();
    }
  }, [initialized]);

  return null;
});
